import styled from 'styled-components';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { ButtonIconText } from '@components/_universal/ButtonIconText/ButtonIconText';
import { IconWrapper } from '@components/_universal/ButtonIconText/ButtonIconText.styled';

import { breakpoints } from '@shared/constants';

export const StyledContainerInner = styled(ContainerInner)`
    align-items: center;
    position: relative;

    @media (max-width: ${breakpoints.lg}px) {
        margin-left: 25px;
    }

    @media (max-width: ${breakpoints.md}px) {
        flex-direction: row;
    }

    @media (max-width: ${breakpoints.xs}px) {
        margin-left: 0;
    }
`;

export const StyledContainerSection = styled(ContainerSection)`
    align-items: center;
    display: flex;
    flex: 2;
    justify-content: flex-end;

    @media (max-width: ${breakpoints.sm}px) {
        position: absolute;
        right: 0;
        width: 100%;
    }
`;

export const SearchWrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export const StyledButtonIconText = styled(ButtonIconText)`
    padding: 0;

    @media (max-width: ${breakpoints.sm}px) {
        bottom: 60px;
        position: fixed;
        right: 15px;
        z-index: 99;

        ${IconWrapper} {
            margin-left: 0;
        }
    }
`;
